import React, { memo } from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const GOOGLE_SVG_URL =
  'https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg';

const GoogleIcon = ({ className }) => (
  <SvgIcon
    component={() => <img className={className} src={GOOGLE_SVG_URL} alt="" />}
  />
);

export default memo(GoogleIcon);
